import { render, staticRenderFns } from "./RecyclableTest.vue?vue&type=template&id=fb28fbee&scoped=true&"
import script from "./RecyclableTest.vue?vue&type=script&lang=js&"
export * from "./RecyclableTest.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableTest.vue?vue&type=style&index=0&id=fb28fbee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb28fbee",
  null
  
)

export default component.exports